import logo from './logo.svg';
import './App.css';
import LandingPage from './components/views/landingPage/landingPage';
import Dashboard from './components/views/dashboard/dashboard';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
function App() {
  return (

    <Router>

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
